module.exports = __webpack_public_path__ + "media/GCC/7. Banner - Preguntas-frecuentes-7918dd5e.png";